import {
  FeatureExplanationModalSmartSearchComponent
} from '../../app/components/feature-explanation-modal-smart-search/feature-explanation-modal-smart-search.component';
import { ExplainModuleEnum } from 'src/app/core/user/user.model';

export const FEATURE_PREFIX = 'feature-highlight-';

export const FEATURES: {[key: string]: { module?: ExplainModuleEnum, modalComponent: any }} = {
  'smart-search': {
    module: ExplainModuleEnum.TERRITORY_INTEL,
    modalComponent: FeatureExplanationModalSmartSearchComponent
  }
};
